import * as React from 'react';
import classNames from 'classnames';

import Dialog, { DialogContent, DialogControls } from '../Dialog/Dialog';
import { NotificationContent, NotificationType } from '../../services/NotificationService';
import ThemeDefinition from '../../domain/ThemeDefinition';
import { useUiLabel } from '@canvas-logic/clp-shared-ui';

import styles from './Notification.module.css';

interface IProps {
  className?: string;
  type: NotificationType;
  content: NotificationContent;
  onClose?: (doNotShowAgain: boolean) => void;
  canBeMuted?: boolean;
}

const Notification: React.FC<IProps> = ({ className, type, content, onClose, canBeMuted }) => {
  const muteLabel = useUiLabel('ui.notification.muteToggle');
  const [doNotShowAgain, setDontShowAgain] = React.useState(false);

  const handleOkClick = React.useCallback(() => {
    if (onClose) {
      onClose(doNotShowAgain);
    }
    setDontShowAgain(false);
  }, [onClose, doNotShowAgain]);

  const handleOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const checked = event.target.checked;
    setDontShowAgain(checked);
  };

  return (
    <Dialog
      className={classNames(
        styles.root,
        ThemeDefinition.notification.root,
        {
          [styles.error]: type === NotificationType.ERROR,
          [ThemeDefinition.notification.error]: type === NotificationType.ERROR,
        },
        className,
      )}
    >
      <DialogContent>{content}</DialogContent>
      {canBeMuted && (
        // <Checkbox
        //     label={<FormattedMessage id="ui.notifications.mute"/>}
        //     checked={doNotShowAgain}
        //     onChange={setDontShowAgain}
        // />
        <>
          <input id="do-not-show-again" type="checkbox" checked={doNotShowAgain} onChange={handleOnChange} />
          <label htmlFor="do-not-show-again">{muteLabel}</label>
        </>
      )}
      <DialogControls>
        <button type="button" onClick={handleOkClick}>
          Ok
        </button>
      </DialogControls>
    </Dialog>
  );
};

export default Notification;
